import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { SystemService } from 'src/app/service/system.service';
import { FileService } from 'src/app/service/file.service';
import { TranslateService } from '@ngx-translate/core';
// import { RoleService } from '../../../service/role.service';
// import { IspService } from '../../../service/isp.service';
// import { UserService } from '../../../service/user.service';


@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;
  thanawyaPrecentageId = 100402;
  thanawyaGradeIdMin = 100401;
  thanawyaGradeIdMax = 100400;
  admissionOpenId = 100403;
  thanawyaPrecentage = 0;
  thanawyaGradeMin = 0;
  thanawyaGradeMax = 0;
  thanawyaCertFile: any;
  thanawyaCertFileName: any;
  thanawyaCardFile: any;
  thanawyaCardFileName: any;
  nidFile: any;
  nidFileName: any;
  fullNameEnglish: any;
  fullNameArabic: any;

  userInfo = {
    ISPID: 120105,
    Username: "Shady.abdallah@vodafone.com",
    Userstatus: "Activated",
    MobileNumber: "01002200020",
    UserType: "Internal",
    RoleType: "ISPAdmin",
    NationalID: "29502220112098"
  }
  avaRoles: any;
  allIsps: any;
  currentLang: string = "en";

  createUser = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),
      // Validators.pattern('^[a-zA-Z0-9-_]([.](?![.])|[a-zA-Z0-9-_])*([@](?![@])|[a-zA-Z])([.](?![.])|[a-zA-Z])*[a-zA-Z]$'),
    ]),
    bachelorScore: new FormControl('', [
      Validators.required,
      Validators.pattern("^[0-9]*$")

    ]),
    nationalID: new FormControl('', [
      Validators.required,
      Validators.pattern(/(2|3)[0-9][0-9][0-1][0-9][0-3][0-9](01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/)
    ]),
    bachelorPercentage: new FormControl('', [
      // Validators.required,
    ]),
    bachelorCert: new FormControl('', [
      Validators.required,
    ]),
    nIDFile: new FormControl('', [
      Validators.required,
    ]),
    bachelorCard: new FormControl('', [
      Validators.required,
    ]),
    nameArabic1: new FormControl('', [
      Validators.required,
      Validators.pattern(/[\u0621-\u064A]+/g)
    ]),
    nameArabic2: new FormControl('', [
      Validators.required,
      Validators.pattern(/[\u0621-\u064A]+/g)
    ]),
    nameArabic3: new FormControl('', [
      Validators.required,
      Validators.pattern(/[\u0621-\u064A]+/g)
    ]),
    nameArabic4: new FormControl('', [
      Validators.required,
      Validators.pattern(/[\u0621-\u064A]+/g)
    ]),
    nameEnglish1: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z\s]+$/)
    ]),
    nameEnglish2: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z\s]+$/)
    ]),
    nameEnglish3: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z\s]+$/)
    ]),
    nameEnglish4: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z\s]+$/)
    ]),
  });

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService,
    private admService: AdmService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, private systemService: SystemService, public translate: TranslateService, private fileService: FileService) {

  }

  changeRole(e: any) {
    this.createUser.value.roleType = e.target.value, {
      onlySelf: true
    }
  }
  ngOnInit(): void {
    this.checkRegOpen();
    this.currentLang = this.globals.lang;
  }

  changeLang(lang: string) {
    // console.log("test : " + this.loginForm.controls.lang.value);
    this.currentLang = lang;
    this.globals.changeLang(this.currentLang);
    // setTimeout(() => {
    //   console.log('sleep');
    //   this.translate.use(this.currentLang);
    //   // And any other code that should run only after 1s
    // }, 1000);
    this.translate.use(this.currentLang);

  }

  checkRegOpen() {
    this.showLoader = true;
    this.systemService.getSystemModuleParamValue(this.admissionOpenId)
      .subscribe(
        data => {
          let value = data.parameterValue;
          if (value == "YES") {
            this.getThanawyaGradeMin();
            // this.getThanawyaGradeMax();
            // this.getThanawyaPrecentage();
          } else {
            this.router.navigate(['/home']);
            this.toastrService.warning(this.translate.instant("REGISTRATION_NOT_OPEN_YET"));
          }
        },
        error => {
          this.router.navigate(['/home']);
          this.toastrService.error(this.translate.instant("CAN_NOT_GET_REGISTRATION_STATUS"));
        }
      );
  }

  registrationChange() {

  }

  createUserSubmit() {
    // if (this.createUser.valid) {
    //   // call your service 
    //   this.addUser(this.createUser.value.email, this.createUser.value.mobile, this.createUser.value.nationalID, this.createUser.controls.roleType.value, this.createUser.controls.ISPName.value)
    // }
    // else {
    //   this.createUser.markAllAsTouched();
    //   this.createUser.markAsDirty();
    // }
  }

  addUser(username: string, mobileNumber: string, nationalId: string, role: any, isp: any) {

  }

  registrationSubmit() {
    // var fullNameEnglishSplitted = this.createUser.controls.fullNameEnglish.value.split(" ");
    // var fullNameArabicSplitted = this.createUser.controls.fullNameArabic.value.split(" ");
    // console.log(fullNameEnglishSplitted)
    // console.log(fullNameArabicSplitted)
    // if(fullNameEnglishSplitted.length<4 || fullNameArabicSplitted.length<4){
    //   this.toastrService.error(this.translate.instant("NAME_LENGTH_LIMIT"));
    // }else{
    this.fullNameEnglish = this.createUser.controls.nameEnglish1.value.concat(" ", this.createUser.controls.nameEnglish2.value
      , " ", this.createUser.controls.nameEnglish3.value, " ", this.createUser.controls.nameEnglish4.value);
    this.fullNameArabic = this.createUser.controls.nameArabic1.value.concat(" ", this.createUser.controls.nameArabic2.value
      , " ", this.createUser.controls.nameArabic3.value, " ", this.createUser.controls.nameArabic4.value);
    console.log(this.fullNameEnglish)
    console.log(this.fullNameArabic)
    if (this.createUser.valid) {
      this.creating = true;
      this.handleUploadFiles()
    }
    else {
      this.createUser.markAllAsTouched();
      this.createUser.markAsDirty();
    }
  }
  //  }

  getThanawyaGradeMin() {
    this.systemService.getSystemModuleParamValue(this.thanawyaGradeIdMin)
      .subscribe(
        data => {
          this.thanawyaGradeMin = data.parameterValue;
          // Validators.required,
          this.createUser.controls.bachelorScore.setValidators([Validators.required, Validators.min(this.thanawyaGradeMin)])
          this.getThanawyaGradeMax();
        },
        error => {
          this.router.navigate(['/home']);
          this.toastrService.error(this.translate.instant("CAN_NOT_GET_THANAWYA_GRADE_VALUE"));
        }
      );
  }

  getThanawyaGradeMax() {
    this.systemService.getSystemModuleParamValue(this.thanawyaGradeIdMax)
      .subscribe(
        data => {
          this.thanawyaGradeMax = data.parameterValue;
          // Validators.required,
          this.createUser.controls.bachelorScore.setValidators([Validators.required, Validators.min(this.thanawyaGradeMin), Validators.max(this.thanawyaGradeMax)])
          // this.getThanawyaPrecentage();
          this.showLoader = false;
        },
        error => {
          this.router.navigate(['/home']);
          this.toastrService.error(this.translate.instant("CAN_NOT_GET_THANAWYA_GRADE_VALUE"));
        }
      );
  }

  // getThanawyaPrecentage() {
  //   this.systemService.getSystemModuleParamValue(this.thanawyaPrecentageId)
  //     .subscribe(
  //       data => {
  //         this.thanawyaPrecentage = data.parameterValue;
  //         this.createUser.controls.bachelorPercentage.setValidators([Validators.required, Validators.min(this.thanawyaPrecentage),Validators.max(100)])
  //         this.showLoader = false;
  //       },
  //       error => {
  //         this.router.navigate(['/home']);
  //         this.toastrService.error(this.translate.instant("CAN_NOT_GET_THANAWYA_PERCENTAGE_VALUE"));
  //       }
  //     );
  // }

  checkFile(event: any, type: string) {

    let typesAccept = ['image/png', 'image/jpeg', 'image/jpg'];
    // Max size 200 MEGA
    let maxSize = 209715200;

    if (event.target.files.length > 0) {
      var currentFile = event.target.files[0];
      console.log("file type: " + currentFile.type);
      // if ((currentFile.type == oldExcel || currentFile.type == excel) && currentFile.size <= maxSize) {
      if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
        console.log("accepted extention");
        if (type == "certFile") {
          this.thanawyaCertFile = event.target.files[0];
        } else if (type == "cardFile") {
          this.thanawyaCardFile = event.target.files[0];
        } else if (type == "nIDFile") {
          this.nidFile = event.target.files[0];
        }

        return true;
      }
      else {
        console.log("wrong extention");
        if (type == "certFile") {
          this.createUser.controls.bachelorCert.reset();
          this.createUser.controls.bachelorCert.markAsDirty();
          this.createUser.controls.bachelorCert.markAsTouched();
        } else if (type == "cardFile") {
          this.createUser.controls.bachelorCard.reset();
          this.createUser.controls.bachelorCard.markAsDirty();
          this.createUser.controls.bachelorCard.markAsTouched();
        } else if (type == "nIDFile") {
          this.createUser.controls.nIDFile.reset();
          this.createUser.controls.nIDFile.markAsDirty();
          this.createUser.controls.nIDFile.markAsTouched();
        }

        if (currentFile.size > maxSize) {
          this.toastr.error(this.translate.instant("MAX_FILE_SIZE_200_MB"))
        }
        return false;
      }
    }
    else {
      return false;
    }
  }

  changeCertFile(event: any) { this.checkFile(event, 'certFile') }

  changeCardFile(event: any) { this.checkFile(event, 'cardFile') }
  changeNIDFile(event: any) { this.checkFile(event, 'nIDFile') }

  handleUploadFiles() {
    let formData = new FormData();

    let fname = this.thanawyaCertFile.name.split('.').slice(0, -1).join('.')
    let fext = this.thanawyaCertFile.name.split('.').pop()
    this.thanawyaCertFileName = fname + "_" + Date.now() + "." + fext
    formData.append('files', this.thanawyaCertFile, this.thanawyaCertFileName);

    fname = this.thanawyaCardFile.name.split('.').slice(0, -1).join('.')
    fext = this.thanawyaCardFile.name.split('.').pop()
    this.thanawyaCardFileName = fname + "_" + Date.now() + "." + fext
    formData.append('files', this.thanawyaCardFile, this.thanawyaCardFileName);

    fname = this.nidFile.name.split('.').slice(0, -1).join('.')
    fext = this.nidFile.name.split('.').pop()
    this.nidFileName = fname + "_" + Date.now() + "." + fext
    formData.append('files', this.nidFile, this.nidFileName);

    console.log("file name : " + this.thanawyaCardFileName + "  " + this.nidFileName)


    this.fileService.uploadMultiFiles(formData).subscribe(
      data => {
        this.handleSaveData()
      },
      error => {
        this.creating = false
        this.toastrService.warning(this.translate.instant("CAN_NOT_UPLOAD_FILES"));
      }
    );
  }

  handleSaveData() {

    let organizationId = this.globals.orgId;
    // New
    let appstatusid = 10;

    this.admService.registriation(
      this.createUser.controls.nationalID.value,
      this.createUser.controls.bachelorScore.value,
      this.createUser.controls.bachelorPercentage.value,
      this.thanawyaCertFileName,
      this.thanawyaCardFileName,
      this.nidFileName,
      this.createUser.controls.email.value,
      organizationId,
      appstatusid,
      this.fullNameArabic,
      this.fullNameEnglish
      // this.createUser.controls.fullNameArabic.value,
      // this.createUser.controls.fullNameEnglish.value
    )
      .subscribe(
        data => {
          if(data.sts=='SUCCESS'){
          // this.router.navigate(['/message?passValue=1']);
          this.router.navigate(['/message'], { queryParams: { passValue: 1 } });
          this.toastrService.success(this.translate.instant("REGISTRATION_DONE"));
        }else{
          this.toastrService.error(data.msg);
        }
        },
        error => {
          this.creating = false
          this.toastrService.warning(this.translate.instant("CAN_NOT_CREATE"));
        },
        () => this.creating = false
      );

  }

  getPrecentage() {
    let studentScore = this.createUser.controls.bachelorScore.value;
    let studPrecentage = 0;
    if (studentScore > 0) {
      studPrecentage = (studentScore * 100) / this.thanawyaGradeMax;
      this.createUser.controls.bachelorPercentage.setValue(studPrecentage.toFixed(2));
    }
  }

}
